// This icon file is generated automatically.
var PStockOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.13 10.67H.87a.13.13 0 00-.12.13v.87c0 .07.06.13.13.13h12.24c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13zM1.59 8.72l.62.61c.05.05.13.05.18 0l3.66-3.65L7.58 7.2c.2.2.5.2.7 0l4.13-4.11a.13.13 0 000-.18l-.62-.62a.13.13 0 00-.17 0L7.93 5.96 6.41 4.44a.5.5 0 00-.71 0l-4.11 4.1a.12.12 0 000 .18z", "fill-rule": "nonzero" } }] }, "name": "p-stock", "theme": "outlined" };
export default PStockOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PStockOutlined.js
// module id = 3656
// module chunks = 0